export default __webpack_public_path__ + "static/media/medico.d4e0bf31.png";